import LogoLoader from './LogoLoader'

export default LogoLoader
